const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  token: state => state.user.token,

  permission_routes: state => state.permission.routes,
  langType: state => state.lang.langType,

  temporaryObj: state => state.temporary.temporaryObj,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js